/* UserTrigger.tsx generated by @compiled/babel-plugin v2.0.0 */
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports share Compiled style value(s) [styles] which cannot be exported across files (UI Styling Standard: no-exported-css) */
// PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02wBC3%7Bwidth%3A360px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VJgOI%7Bheight%3A6pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
import React, { type ReactNode } from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
const styles = {
  cardWrapper: "_39xV02wBC3",
  spinnerContainer: "_0hPCNLDIqT _3iDTPbQ4SZ _0jFU0VJgOI _37wbyuDIqT _1mT5xdRAKS"
};
export const CardWrapper = ({
  children,
  role,
  testId,
  labelledBy,
  ariaLabel
}: {
  children: ReactNode;
  role?: string;
  testId?: string;
  labelledBy?: string;
  ariaLabel?: string;
}): React.JSX.Element => <Box xcss={cx(styles.cardWrapper)} backgroundColor={'elevation.surface.overlay'} role={role} testId={testId} aria-labelledby={labelledBy} aria-label={ariaLabel}>
		{children}
	</Box>;
export const SpinnerContainer = ({
  children,
  testId
}: {
  children: ReactNode;
  testId?: string;
}): React.JSX.Element => <Box testId={testId} xcss={cx(styles.spinnerContainer)}>
		{children}
	</Box>;